var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display.length > 0)?_c('div',{staticClass:"info_table"},[_c('div',{staticClass:"item"},[_vm._v("总和:"+_vm._s(_vm.display[0]))]),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.display[1]))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }